export default __webpack_public_path__ + "static/media/payCard.4010f636.svg";